
import NotificationTypeEnum from "@/api/dataSource/api/Spirit/Entities/Enums/NotificationTypeEnum";
import CreateEmailPushViewModel from "@models/emailPush/createEmailPushViewModel";
import { Vue, Component } from "vue-property-decorator";

@Component
export default class CreateEmailPushComponent extends Vue {
  languages: string[] = [];
  isLoading = false;
  inited = false;
  get id(): number {
    const routeId = this.$route.params.id;
    return routeId ? Number(routeId) : 0;
  }
  get fieldNamesString(): string {
    return (this.vm.fieldNames || []).join(', ');
  }
  notificationTypes = [
    {id: NotificationTypeEnum.Email, name: 'Email'},
    {id: NotificationTypeEnum.Push, name: 'Пуш'},
    {id: NotificationTypeEnum.Both, name: 'Email и пуш'}
  ]
  vm: CreateEmailPushViewModel = new CreateEmailPushViewModel();
  async created() {
    try {
      this.languages = await this.$cacheProvider.getLanguagesAsync();
      this.vm.initLanguages(this.languages);
      if (this.$route.params.id) {
        await this.fetchData();
      }
      this.inited = true;
    } catch (error) {
      this.$notification.error(error);
    }
  }
  async fetchData() {
    this.isLoading = true;
    try {
      const res = await this.$api.NotificationService.getDetailAsync(this.id);
      this.vm.fromServerModel(res);
    } catch (error) {
      this.$notification.error(error);
    } finally {
      this.isLoading = false;
    }
  }
  toCopyBuffer(text: string) {
    if (this.$copyPaste.execute(text)) {
      this.$notification.success('Скопировано в буфер обмена');
    } else {
      this.$notification.error('Ошибка при копировании в буфер обмена');      
    }
  }
  async save() {
    if (!(this.$refs.translationTabs as any).isValid()) return;
    const isValid = (this.$refs.validator as any).isValid();
    if (!isValid) return;
    const isTemplateValid = this.vm.isValidTemplate();
    if (!isTemplateValid) {
      this.$notification.error(`Заполните шаблон необходимыми полями! (${this.fieldNamesString})`);
      return;
    }
    this.isLoading = true;
    try {
      const request = this.vm.toServerModel();
      const res = await this.$api.NotificationService.updateAsync(
        request
      );
      if (res) {
        this.$dialog.success("Уведомление успешно обновлено");
        this.$router.back();
      }
    } catch (error) {
      this.$notification.error(error);
    } finally {
      this.isLoading = false;
    }
  }
}
